

function strCmp(a, b) {
  return Boolean(a && a?.toLowerCase() === b?.toLowerCase());
}

export function isType(type) {
  return application => strCmp(application.type, type);
}
